define('gigaset_csp/components/support/detail/intro',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/components/Registry",
	"cartware/jquery/bem"
], function(
	$,
	_,
	Component,
	Registry,
	BEM
) {

	var BLOCK = "csp-support-detail-introduction";

	return Component.create({

		$init: function() {
			var self = this;
			this.block = BEM.block(BLOCK);

			Registry().retrieve("system.dispatcher", function(dispatcher) {
				var handles = dispatcher.getHandles();

				_.forEach({
					"faq":				"intro-faq",
					"downloads":		"intro-downloads",
					"accessories":		"intro-accessories",
					"compatibility":	"intro-compatibility",
					"registration":		"intro-registration",
					"contact":			"intro-contact",
					"videotutorials":	"intro-videotutorials",
					"repair":			"intro-repair"
				}, function(value, key) {
					var element = self.block.getElements(value);

					if (key === "accessories") {
						element.css("display", _.trim(self.block.getElements("block-accessories").text()) !== "" ? "" : "none");
					} else {
						element.css("display", _.indexOf(handles, "gigaset_csp_support_detail_" + key) >= 0 ? "" : "none");
					}
				});

				self.block.bemAddModifier("ready");
			});
		}

	});
});
